import {
  FormControl,
  FormControlProps,
  FormErrorMessage,
  FormLabel,
  FormLabelProps,
  Switch,
  SwitchProps
} from '@chakra-ui/react';
import { Controller, useFormContext } from 'react-hook-form';

interface Props {
  label: string;
  name: string;
  defaultValue?: boolean;
  formControlProps?: FormControlProps;
  formLabelProps?: FormLabelProps;
  switchProps?: SwitchProps;
}

export function SwitchFormControl({
  label,
  name,
  defaultValue,
  formControlProps,
  formLabelProps,
  switchProps
}: Props) {
  const {
    control,
    formState: { errors }
  } = useFormContext<{ [key: string]: boolean }>();

  return (
    <Controller
      defaultValue={defaultValue}
      control={control}
      name={name}
      render={({ field, fieldState: { error } }) => (
        <FormControl isInvalid={!!errors[name]?.message} {...formControlProps}>
          <FormLabel htmlFor={name} {...formLabelProps}>
            {label}
          </FormLabel>
          <Switch
            id={name}
            onChange={(e) => field.onChange(e.target.checked)}
            onBlur={() => field.onBlur()}
            checked={field.value}
            {...switchProps}
          />
          {error?.message && <FormErrorMessage>{error?.message}</FormErrorMessage>}
        </FormControl>
      )}
    />
  );
}
